import { render, staticRenderFns } from "./mo-person-search-source.html?vue&type=template&id=3e94a140&scoped=true&external"
import script from "./mo-person-search-source.ts?vue&type=script&lang=ts&external"
export * from "./mo-person-search-source.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94a140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e94a140')) {
      api.createRecord('3e94a140', component.options)
    } else {
      api.reload('3e94a140', component.options)
    }
    module.hot.accept("./mo-person-search-source.html?vue&type=template&id=3e94a140&scoped=true&external", function () {
      api.rerender('3e94a140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/persoon/mo-person-search-source/mo-person-search-source.vue"
export default component.exports